import { computed } from "vue";
import { DS_STATE_CLASSES } from "@/src/design_system/shared/constants/stateClasses";

export const useStateClasses = (props: { disabled?: boolean; hasError?: boolean; errorMessages?: string[] }) => {
  const stateClasses = computed(() => ({
    [DS_STATE_CLASSES.Disabled]: !!props.disabled,
    [DS_STATE_CLASSES.Error]: props.hasError || (props.errorMessages?.length ?? 0) > 0,
  }));

  return { stateClasses };
};
